import React, { useEffect, useState, useRef } from "react";
import "../styles/AddBranch.css";
import { useNavigate } from "react-router-dom";
import BusinessHubHeader from "../components/BusinessHubHeader";
import BackArrow from "../icons/BusinessHub/BackArrow";
import SuccTickIcon from "../icons/BusinessHub/SuccTickIcon";
import { useLocation } from "react-router-dom";
import Uploadbutton from "../icons/BusinessHub/Uploadbutton";
import { userService } from "../services/userService";
import companyController from "../controllers/companyController";
import { toast } from "react-toastify";
import Utils from "../utils/Utils";

function RelatedCompData() {
  const ownerIDPassportRef = useRef(null);
  const PoliceClearanceCertificateRef = useRef(null);
  const ProofLegalEntityRef = useRef(null);
  const [ownerIDPassport, setOwnerIDPassport] = useState({ name: "" });
  const [PoliceClearanceCertificate, setPoliceClearanceCertificate] = useState({
    name: "",
  });
  const [ProofLegalEntity, setProofLegalEntity] = useState({ name: "" });

  /**************************** */
  const { state } = useLocation();
  const jwt = userService.getUser();

  const navigate = useNavigate();
  const [submitted, setSubmitted] = useState(false);
  // const [termsPop, setTermsPop] = useState(false);
  // const [ischecked, setIschecked] = useState(false);
  useEffect(() => {
    const parsed = Utils.parseJwt(jwt);
    const businessProfileID = userService.getBPID();

    const getCompaniesData = async () => {
      const getCompanies = await companyController.getBusinesProfileCompanies({
        Authorization: jwt,
        businessProfileID: businessProfileID,
      });
    };
    getCompaniesData();
  }, []);
  const handleSubmit = async () => {
    const parsed = Utils.parseJwt(jwt);
    const companyID = userService.getCompID();

    /************* */
    const copmayRequest = {
      businessProfileID: userService.getBPID(),
      companyId: companyID,
    };
    const compDetails = await companyController.getCompanyDetails({
      copmayRequest: copmayRequest,
      Authorization: jwt,
    });
    /************* */

    // attachmentType: null,
    const addAttachments = {
      attachmentType: null,
      companyID: companyID,
      customObject: [
        {
          attachmentStatus: "DEFAULT",
          attachmentType: "ID",
          countryName: compDetails.data.countryName,
          customPath: "test",
          data: ownerIDPassport.base64,
          extension: ownerIDPassport.name.split(".").pop(),
          objectName: ownerIDPassport.name,
          userName: parsed.username,
        },
        {
          attachmentStatus: "DEFAULT",
          attachmentType: "POLICE_CLEARANCE",
          countryName: compDetails.data.countryName,
          customPath: "test",
          data: PoliceClearanceCertificate.base64,
          extension: PoliceClearanceCertificate.name.split(".").pop(),
          objectName: PoliceClearanceCertificate.name,
          userName: parsed.username,
        },
        {
          attachmentStatus: "DEFAULT",
          attachmentType: "PROOF_OF_LEAGALITY",
          countryName: compDetails.data.countryName,
          customPath: "test",
          data: ProofLegalEntity.base64,
          extension: ProofLegalEntity.name.split(".").pop(),
          objectName: ProofLegalEntity.name,
          userName: parsed.username,
        },
      ],
    };
    // businessProfileID: Object.values(parsed.userDetails)[0].busienssProfileID,
    //   companyCity: childDTO.City,
    //   companyCountry: childDTO.country,
    //   companyID: companyID,
    //   companyName: childDTO.BranchName,
    // companyStatus: "PENDING",
    // taxNumber: "44444",
    // companyType: "BRANCH",
    try {
      const response = await companyController.updateAddCompanyAttachments({
        addAttachments: addAttachments,
        Authorization: jwt,
      });
      if (Utils.isSuccessResponse(response)) {
        toast.success("successfully!");
        setSubmitted(true);
      }
    } catch (err) {
      console.error("Company registration failed", err);
    }
  };

  return (
    <div>
      <div className="create-branch-page-header">
        <BusinessHubHeader />
      </div>

      <div className="create-branch-content-main-container">
        {/* {submitted && (
          <div className="add-branch-popup-container">
            <div
              className="edit-role-popup-content-container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="edit-role-popup-content">
                <div className="edit-role-successfully-added-icon">
                  <SuccTickIcon />
                </div>
                <div className="edit-role-successfully-added-text">
                  Temporary Activation
                </div>
                <div className="comp-reg-data-review-note">
                  Since you’re already an approved partner, your branch /
                  warehouse is active for now. <br />
                  <b>
                    Please upload the required documents within 2 months to
                    complete verification.
                  </b>
                </div>
                <div
                  className="uploud-branch-required-data"
                  onClick={() =>
                    navigate("/user-management", { state: { active: "A" } })
                  }
                >
                  Skip for now
                </div>
                <div
                  className="edit-role-successfully-added-action-button"
                  onClick={() => navigate("/Related-CompData")}
                >
                  Proceed
                </div>
              </div>
            </div>
          </div>
        )} */}
        {submitted && (
          <div className="edit-role-popup-container">
            <div
              className="edit-role-popup-content-container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="edit-role-popup-content">
                <div className="edit-role-successfully-added-icon">
                  <SuccTickIcon />
                </div>
                <div className="edit-role-successfully-added-text">
                  Verification in Progress
                </div>
                <div className="comp-reg-data-review-note">
                  We are currently reviewing your legal documents, tax number,
                  and ID. Until your information is fully verified, your access
                  will remain limited as a guest. <br />
                  <b>
                    We will notify you once your account is approved and
                    activated.
                  </b>
                </div>
                <div
                  className="edit-role-successfully-added-action-button"
                  onClick={() =>
                    navigate("/user-management", { state: { active: "A" } })
                  }
                >
                  Go to Business Overview
                </div>
              </div>
            </div>
          </div>
        )}
        {/* {termsPop && (
          <div className="branch-create-popup-container">
            <div
              className="branch-create-popup-content-container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="branch-create-popup-content">
                <div className="branch-create-successfully-added-text">
                  Terms and Conditions
                </div>
                <div className="branch-create-successfully-added-icon">
                  Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
                  diam nonummy nibh euismod tincidunt ut laoreet dolore magna
                  aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                  nostrud exerci tation ullamcorper suscipit lobortis nisl ut
                  aliquip ex ea commodo consequat. Duis autem vel eum iriure
                  dolor in hendrerit in vulputate velit esse molestie consequat,
                  vel illum dolore eu feugiat nulla facilisis at vero eros et
                  accumsan et iusto odio dignissim qui blandit praesent luptatum
                  zzril delenit augue duis dolore te feugait nulla facilisi.
                  Lorem ipsum dolor sit amet, cons ectetuer adipiscing elit, sed
                  diam nonummy nibh euismod tincidunt ut laoreet dolore magna
                  aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                  nostrud exerci tation ullamcorper suscipit lobortis nisl ut
                  aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet,
                  consectetuer adipiscing elit, sed diam nonummy nibh euismod
                  tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut
                  wisi enim ad minim veniam, quis nostrud exerci tation
                  ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                  consequat.
                </div>
                <div className="branch-reg-info-input-body-doc-agree">
                  <input
                    type="checkbox"
                    checked={ischecked}
                    onChange={(e) => setIschecked(e.target.checked)}
                  />
                  <div>I agree with the terms and conditions</div>
                </div>
                <div
                  className="branch-create-successfully-added-action-button"
                  style={{
                    opacity: ischecked ? 1 : 0.5,
                    pointerEvents: ischecked ? "auto" : "none",
                    cursor: ischecked ? "pointer" : "not-allowed",
                  }}
                  onClick={() => {
                    setTermsPop(false);
                    setSubmitted(true);
                  }}
                >
                  Accept
                </div>
              </div>
            </div>
          </div>
        )} */}

        <div className="create-branch-content-container">
          <div className="create-branch-data-header">
            <div className="create-branch-header-navigation">
              <div
                className="create-branch-header-navigation-icon"
                onClick={() =>
                  navigate("/user-management", { state: { active: "A" } })
                }
              >
                <BackArrow />
              </div>
              <div className="create-branch-header-navigation-text">
                Back to Business Overview
              </div>
            </div>

            <div className="create-branch-header-text">
              <div className="create-branch-header-title">Add Branch </div>
              <div className="create-branch-header-text-note">
                Fill in all required fields.
              </div>
            </div>
          </div>

          <div className="create-branch-body">
            <div className="branch-reg-window-container">
              {/* <RelatedBInput onDataChange={setChildDTO} /> */}
              <div className="related-comp-input-data">
                <div className="intddriver-reg-info-input-body-doc">
                  <div className="intddriver-reg-info-input-body-doc-title">
                    Required Documents
                  </div>

                  {/**********************************************************/}
                  <div className="intddriver-reg-info-input-body-doc-data">
                    {/*Owner ID/ Passport*/}
                    <div className="intddriver-reg-info-input-body-doc-data-rows">
                      <div className="intddriver-reg-info-data-input-cont">
                        Owner ID/ Passport <div className="required">*</div>
                      </div>
                      <div
                        className="verification-documents-input-container"
                        onClick={() => ownerIDPassportRef.current?.click()}
                      >
                        <div className="verification-documents-icon">
                          <Uploadbutton />
                        </div>
                        <input
                          type="file"
                          ref={ownerIDPassportRef}
                          style={{ display: "none" }}
                          onChange={async (e) => {
                            const file = e.target.files[0];
                            if (!file) return;

                            try {
                              const fileData =
                                await Utils.processImageFile(file);
                              setOwnerIDPassport(fileData);
                            } catch (err) {
                              alert(err.message);
                            }
                          }}
                        />
                        <input
                          placeholder="ID or Passport Image"
                          className="verification-documents-input"
                          value={ownerIDPassport.name}
                          readOnly
                        />
                      </div>
                    </div>

                    {/*Police Clearance Certificate*/}
                    <div className="intddriver-reg-info-input-body-doc-data-rows">
                      <div className="intddriver-reg-info-data-input-cont">
                        Police Clearance Certificate{" "}
                        <div className="required">*</div>
                      </div>
                      <div
                        className="verification-documents-input-container"
                        onClick={() =>
                          PoliceClearanceCertificateRef.current?.click()
                        }
                      >
                        <div className="verification-documents-icon">
                          <Uploadbutton />
                        </div>
                        <input
                          type="file"
                          ref={PoliceClearanceCertificateRef}
                          style={{ display: "none" }}
                          onChange={async (e) => {
                            const file = e.target.files[0];
                            if (!file) return;

                            try {
                              const fileData =
                                await Utils.processImageFile(file);
                              setPoliceClearanceCertificate(fileData);
                            } catch (err) {
                              alert(err.message);
                            }
                          }}
                        />
                        <input
                          placeholder="Certificate Image"
                          className="verification-documents-input"
                          value={PoliceClearanceCertificate.name}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>

                  <div className="intddriver-reg-info-input-body-doc-data-row">
                    {/*Proof of Legal Entity*/}
                    <div className="intddriver-reg-info-data-input-cont">
                      Proof of Legal Entity
                      <div className="required">*</div>
                    </div>
                    <div
                      className="verification-documents-input-container"
                      onClick={() => ProofLegalEntityRef.current?.click()}
                    >
                      <div className="verification-documents-icon">
                        <Uploadbutton />
                      </div>
                      <input
                        type="file"
                        ref={ProofLegalEntityRef}
                        style={{ display: "none" }}
                        onChange={async (e) => {
                          const file = e.target.files[0];
                          if (!file) return;

                          if (!file.type.startsWith("image/")) {
                            alert("Only image files are allowed");
                            return;
                          }

                          if (file.size > 50 * 1024 * 1024) {
                            alert("Max file size is 50MB");
                            return;
                          }
                          try {
                            const fileData = await Utils.processImageFile(
                              file,
                              8,
                            );
                            setProofLegalEntity(fileData);
                          } catch (err) {
                            alert(err.message);
                          }
                        }}
                      />
                      <input
                        placeholder="Proof Image"
                        className="verification-documents-input"
                        value={ProofLegalEntity.name}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="branch-reg-info-input-footer">
                <div
                  className="branch-reg-submit-action-button"
                  onClick={handleSubmit}
                  // style={{
                  //   opacity: ischecked ? 1 : 0.5,
                  //   pointerEvents: ischecked ? "auto" : "none",
                  //   cursor: ischecked ? "pointer" : "not-allowed",
                  // }}
                >
                  Submit
                </div>
                <div
                  className="branch-reg-cancel-action-button"
                  onClick={() =>
                    navigate("/user-management", { state: { active: "A" } })
                  }
                >
                  Cancel
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RelatedCompData;
